import React from 'react';
import { Card } from '../components/ui/Card';
export function AboutPage() {
  return <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-144">
      <div className="text-center mb-12" data-id="element-145">
        <h1 className="text-4xl md:text-6xl font-retro text-white mb-4" data-id="element-146">
          Our Story
        </h1>
        <div className="w-24 h-1 bg-primary mx-auto" data-id="element-147"></div>
      </div>

      <div className="space-y-12" data-id="element-148">
        <section className="grid md:grid-cols-2 gap-8 items-center" data-id="element-149">
          <div data-id="element-150">
            <h2 className="text-2xl font-retro text-primary mb-4" data-id="element-151">
              More Than A Convenience Store
            </h2>
            <p className="text-gray-300 leading-relaxed mb-4" data-id="element-152">
              Located at the corner of Smith Road & East 10th Street, Short Stop
              Food Mart has been a staple of the Bloomington community for
              years. We're not just a place to grab gas and go - we're a
              destination for food lovers.
            </p>
            <p className="text-gray-300 leading-relaxed" data-id="element-153">
              Our famous "BBQ Train" smoker sits proudly outside, churning out
              the best smoked meats in town every week. It's a labor of love
              that brings our neighbors together.
            </p>
          </div>
          <div className="rounded-xl overflow-hidden shadow-2xl border border-gray-800" data-id="element-154">
            <img src="https://images.unsplash.com/photo-1529193591184-b1d580690dd0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Store Front" className="w-full h-full object-cover" data-id="element-155" />
          </div>
        </section>

        <Card className="p-8 bg-dark-card border-primary/30" data-id="element-156">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-157">
            <div className="w-32 h-32 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-primary flex-shrink-0" data-id="element-158">
              <img src="https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Beans the BBQ Dog" className="w-full h-full object-cover" data-id="element-159" />
            </div>
            <div data-id="element-160">
              <h3 className="text-2xl font-retro text-white mb-2" data-id="element-161">
                Meet Beans
              </h3>
              <p className="text-primary font-bold uppercase tracking-wider text-sm mb-4" data-id="element-162">
                Official BBQ Inspector
              </p>
              <p className="text-gray-300 italic" data-id="element-163">
                "Beans has been approving our BBQ recipes since day one. If it
                doesn't get a tail wag from Beans, it doesn't make it to the
                menu. He's the heart and soul of the Short Stop operation."
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}